import { Component, Inject, QueryList, ViewChildren } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BRANDING_LS_KEY, DynamicBrandingService } from '@boxx/dynamic-branding';
import { LoginService, LoginStore, TUTORIAL_SEEN_KEY, USER_TOKEN_KEY } from '@boxx/login-core';
import {
  OnboardingService,
  OnboardingStore,
  ONBOARDING_BUSINESS_CONFIG_KEY,
  ONBOARDING_REGISTRATION_KEY,
} from '@boxx/onboarding-core';
import { SplashScreen } from '@capacitor/splash-screen';
import { IonRouterOutlet, LoadingController, MenuController, ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, skip, takeUntil, withLatestFrom } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { LocalNotificationsService } from 'src/services/NativeLocalNotification.service';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { SharingService } from 'src/services/NativeSharing.service';
import {
  AvailableLanguageKeys,
  AVAILABLE_LANGUAGES,
  SELECTED_LANGUAGE_LS_KEY,
} from 'src/services/translate/languagesData';
import { TranslateConfigService } from 'src/services/translate/translate-config.service';
import { Capacitor } from '@capacitor/core';
import { ScorePickerComponent } from '@boxx/shared-components/lib/score-picker/score-picker.component';
import { ProfileModel } from '@boxx/profile-core/lib/models/profile.model';
import { ProfileStore } from '@boxx/profile-core/lib/state/profile.store';
import { Browser } from '@capacitor/browser';
import { INativeStorageService, NATIVE_STORAGE_SERVICE } from '@boxx/core/lib/contracts/IAppConfigService';
import { register } from 'swiper/element/bundle';
import { BusinessService } from './pages/home/services/business.service';
// import { OptionsSupportPage } from './pages/support/options-support/options-support.page';
// import { GmbStatusPage } from './pages/account/gmb-status/gmb-status.page';
import { SupportComponent } from './pages/support/components/support/support.component';
import { GmbStatusPage } from './pages/home/components/gmb-status/gmb-status.page';

register();
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  @ViewChildren(IonRouterOutlet) routerOutlets: QueryList<IonRouterOutlet>;
  favIcon: HTMLLinkElement = document.querySelector('#appIcon');
  pageTitle: HTMLLinkElement = document.querySelector('#appTitle');
  appLanguage: string;

  isIos = false;
  isCordovaOrCapacitor = false;
  isProdMode = environment.production;

  appPages = [
    {
      title: 'CONFIGURATION_MODULE.wizardItem',
      url: '/tabs/account/setup-wizard',
      // icon: 'business',
      iconSrc: 'assets/icon/Icon_SubMenuProfile_Preferences.svg',
    },
    {
      title: 'SIDEMENU.faqsItem',
      url: 'faqs',
      iconSrc: './assets/icon/Icon_SubMenuFaqs.svg',
    },
    {
      title: 'SIDEMENU.supportItem',
      url: 'support',
      iconSrc: './assets/icon/Icon_SubMenuSupport.svg',
    },
  ];

  isLoggedIn = false;
  translations: any = {};
  loading = false;

  enableMainMenu = false;
  enableHelpMenu = false;
  enableEmbeddedHelpMenu = false;
  embeddedHelpViewName: 'faqs' | 'support';
  isLoginView = false;
  isWelcomeView = false;

  wasLoggedIn = false;

  destroyed$ = new Subject<boolean>();
  gmbPage = 'gmb-sync';
  showNotificacionToast = true;

  brandName: string;
  previousRate: boolean;
  previousStars: number;
  previousReview: string;
  stars: number;
  hasReview: boolean;
  profile: ProfileModel = ProfileModel.empty();
  logoUrl: string;

  p_businessName: string;
  p_userEmail: string;
  lastUrl: string;
  platformName: string;

  showWizardItem = false;

  showSalesBlock = false;
  showWebBlock = false;
  showListingBlock = false;
  businessInfo: any;


  //SKUS
  hasWebSite = false;
  hasStore = false;
  allowNFC = false;
  //End SKUS

  constructor(
    private platform: Platform,
    private translateService: TranslateService,
    private storageService: LocalStorageNativeService,
    public router: Router,
    private authSrvc: LoginService,
    public loginStore: LoginStore,
    private sharingSrvc: SharingService,
    private localNotifSrvc: LocalNotificationsService,
    public loadingCtrl: LoadingController,
    private onboardingStore: OnboardingStore,
    private store: ProfileStore,
    private boxxUtils: BoxxUtilsService,
    private translateConfig: TranslateConfigService,
    private dBrandingService: DynamicBrandingService,
    private viewCtrl: ModalController,
    private menuCtrl: MenuController,
    private businessService: BusinessService,
    //public businessService: OnboardingService,
    @Inject(NATIVE_STORAGE_SERVICE) private localStge: INativeStorageService
  ) {
    platform.ready().then(() => {
      //permisonsService.listenAuthChanges();
      this.initializeApp();

    });

    // this.onboardingStore.businessConfig.gmbStatusData$
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe(async (gmbData) => {
    //     console.log('new gmbdata');
    //     //this.gmbStatus = gmbData.status;
    //   });
    // for testing,
    // TODO: insert the item by comparing a flag provided by the backend
    this.dBrandingService.themeChange$.subscribe(brandName => {

      if ((brandName && brandName !== undefined) && brandName.toUpperCase() === 'GETNET') {
        document.documentElement.style.setProperty('--ion-color-custom-background-color', '#c20e2a');
        document.documentElement.style.setProperty('--ion-color-custom-title-color', '#ffffff');
        document.documentElement.style.setProperty('--ion-color-secondary', '#ffffff');
        document.documentElement.style.setProperty('--ion-color-button', 'linear-gradient(#f20403, #ad1324)');
        document.documentElement.style.setProperty('--ion-color-primary', 'linear-gradient(#f20403, #ad1324)');
      }

      //if (['telmex', 'totalplay'].includes(brandName.toLowerCase())) {
      this.appPages = this.appPages.filter(
        item => item.title !== 'ONBOARDING_MODULE.gmbSideMenuTitle'
      );

      // this.store.data$.pipe(takeUntil(this.destroyed$)).subscribe((p) => {
      //   if (p.userId) {
      //     this.profile = p;
      //   }
      // });

      // this.store.fetched$
      //   .pipe(takeUntil(this.destroyed$))
      //   .subscribe((fetched) => {
      //     if (!fetched) {
      //       this.store.fetch();
      //     }
      //   });

      this.onboardingStore.businessConfig.businessData$
        .pipe(takeUntil(this.destroyed$))
        .subscribe((businessData) => {
          if (
            !businessData.config.schedule &&
            !businessData.config.services &&
            !businessData.config.payments
          ) {
            this.showWizardItem = true;
          }
          else {
            this.showWizardItem = false;
          }


          if (businessData && businessData.businessId) {
            if (businessData.brand && businessData.brand !== undefined) {
              this.brandName = (businessData.brand.toUpperCase() === 'TELMEX') ? 'CRM TELMEX' : this.clearMNDBrand(businessData.brand.toUpperCase());// (businessData.brand) ? businessData.brand : '';
            }


            this.logoUrl = businessData.images?.logo_image?.content;

            this.p_businessName = businessData.name ? businessData.name : '';
            this.p_userEmail = businessData.businessEmail ? businessData.businessEmail : '';

            this.previousRate = (businessData.score && businessData.score !== undefined) ? businessData.score : false;
            if (this.previousRate) {
              this.previousStars = businessData.stars;
              this.previousReview = businessData.review;
            }
          }
        });

      // if(!this.hasGmbSync){
      //   this.appPages.push({
      //     title: 'ONBOARDING_MODULE.gmbSideMenuTitle',
      //     url: 'gmb-sync',
      //     iconSrc: './assets/icon/Icon_SubMenuProfile_CommunicationsGoogleB.svg',
      //   });
      // }
      // else{
      //   console.log('here es true');
      //   this.appPages.push({
      //     title: 'ONBOARDING_MODULE.gmbSideMenuTitle',
      //     url: 'account/gmb-status',
      //     iconSrc: './assets/icon/Icon_SubMenuProfile_CommunicationsGoogleB.svg',
      //   });
      // }

      // } else {
      //   this.appPages = this.appPages.filter(
      //     item => item.title !== 'ONBOARDING_MODULE.gmbSideMenuTitle'
      //   );
      // }
    });
  }

  clearMNDBrand(brand: string) {
    if (brand.includes("NEGOCIO DIGITAL")) {
      return 'MI NEGOCIO DIGITAL';
    }
    return brand;
  }

  async initializeApp() {
    this.businessService.business$.subscribe((data) => {
      this.businessInfo = data;
      if(data && data !== null && data !== undefined){
        for (let i = 0; i < data.sites.length; i++) {
          if (data.sites[i].type === 'agency_website' || data.sites[i].type === 'website') {
            this.hasWebSite = true;
            break;
          }
        }
        this.hasStore = data.allowStore;
  
        if(data.allow_nfc_sync){
          this.allowNFC = true;
        }
      }
    });

    SplashScreen.show();

    setTimeout(() => {
      SplashScreen.hide({
        fadeOutDuration: 500
      });
    }, 2000);

    const hasToken = await this.localStge.getItem(USER_TOKEN_KEY);
    if (hasToken !== null) {
      await this.router.navigateByUrl('tabs/home');
    }
    else {
      await this.router.navigateByUrl('/onboarding/personal-info');
    }
    let _code: any = 'es';
    //this.translateConfig.setLanguage(_code); 
    this.storageService.setItem(SELECTED_LANGUAGE_LS_KEY, 'es');


    this.platformName = Capacitor.getPlatform();
    this.platform.ready().then(() => {

      if (this.platform.is('android')) {
        document.addEventListener("backbutton", async () => {
          const modal = await this.viewCtrl.getTop();
          if (modal) {
            this.viewCtrl.dismiss();
            return;
          }
          this.routerOutlets.forEach(async (outlet: IonRouterOutlet) => {
            if (this.router.url !== '/tabs/home') {
              if (outlet && outlet.canGoBack()) {
                outlet.pop();
              }
            }
          });

        });


      }

    });

    this.onboardingStore.businessConfig.businessData$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((businessData) => {
        if (businessData && businessData.businessId) {
          this.brandName = (businessData.brand) ? businessData.brand : '';
          this.logoUrl = businessData.images?.logo_image?.content;

          this.p_businessName = businessData.name ? businessData.name : '';
          this.p_userEmail = businessData.businessEmail ? businessData.businessEmail : '';

          this.previousRate = (businessData.score && businessData.score !== undefined) ? businessData.score : false;
          if (this.previousRate) {
            this.previousStars = businessData.stars;
            this.previousReview = businessData.review;
          }
        }

      });

    this.handleLoading();
    this.handleSuccess();
    this.handleError();

    this.translateService.get(['SIDEMENU', 'ACTIONS']).subscribe(t => (this.translations = t));

    this.translateService.onLangChange.subscribe(({ translations }) => {
      this.translations = translations;
    });

    (window as any).skipLocalNotificationReady = true;

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const allowMainMenuRoutes = [
          '/tabs',
          '/tabs/panel',
          '/tabs/messages',
          '/tabs/events',
          '/tabs/contacts',
          '/tabs/account',
        ];

        this.enableMainMenu = allowMainMenuRoutes.some(route => route === event.url);

        const allowHelpMenuRoutes = ['/welcome/create-account', '/login'];
        this.enableHelpMenu = allowHelpMenuRoutes.some(route => route === event.url);

        this.isLoginView = event.url === '/login';
        //this.isWelcomeView = event.url === '/onboarding/register';
      });

    this.isIos = this.platform.platforms().some(name => ['ios', 'ipad', 'iphone'].includes(name));
    this.isCordovaOrCapacitor = this.platform.is('cordova') || this.platform.is('capacitor');

    this.lastUrl = location.pathname;
    const remember = JSON.parse(
      (await this.storageService.getItem('rememberCredentials')) || 'false'
    );

    if (!remember) {
      const hasTuto = (await this.storageService.getItem(TUTORIAL_SEEN_KEY)) === 'OK';
      const obRegistration = await this.storageService.getItem(ONBOARDING_REGISTRATION_KEY);
      const obBusinessConfig = await this.storageService.getItem(ONBOARDING_BUSINESS_CONFIG_KEY);

      //await this.storageService.clearStorage();

      if (hasTuto) {
        this.storageService.setItem(TUTORIAL_SEEN_KEY, 'OK');
      }

      if (obRegistration) {
        this.storageService.setItem(ONBOARDING_REGISTRATION_KEY, obRegistration);
      }
      if (obBusinessConfig) {
        this.storageService.setItem(ONBOARDING_BUSINESS_CONFIG_KEY, obBusinessConfig);
      }
    } else {
      this.storageService.getItem(USER_TOKEN_KEY).then(tokenKey => {
        if (tokenKey) {
          this.authSrvc.getSession().then(user => {
            setTimeout(() => {

              this.loginStore.setUserData(user);
            }, 900);
          });
        } else {

        }
      });
    }
    this.checkEnvironment();


  }

  getBrandKey(brand: string) {
    let appKey = '';
    switch (brand.toUpperCase()) {
      case 'BOXX':
      case 'BOXX CRM':
      case '#BOXX':
        appKey = 'Ym94eA';
        break;
      case 'VENTASCLICK':
        appKey = 'VmVudGFzQ2xpY2s';
        break;
      case 'GETNET':
        appKey = 'R2V0TmV0';
        break;
      case 'TOTALPLAY':
        appKey = 'VG90YWxQbGF5';
        break;
      case 'TELMEX':
        appKey = 'dGVsbWV4';
        break;
      case 'TODOSW':
        appKey = 'VG9kb3NX';
        break;
      case 'BUSINESS WOMAN':
        appKey = 'QnVzaW5lc3MgV29tYW4';
        break;
      case 'MI NEGOCIO DIGITAL':
        appKey = 'TWkgTmVnb2NpbyBEaWdpdGFsIE1JY2hvYWNhbg';
        break;
      case 'MI NEGOCIO DIGITAL QUERETARO':
        appKey = 'TWkgbmVnb2NpbyBEaWdpdGFsIFF1ZXJldGFybyA';
        break;


      case 'MUJERES EXTRAORDINARIAS':
        appKey = 'TXVqZXJlcyBFeHRyYW9yZGluYXJpYXM';
        break;
      case 'CASA PUEBLA NEW YORK NEW JERSEY':
        appKey = 'Q0FTQSBQVUVCTEEgTkVXIFlPUksgTkVXIEpFUlNFWQ';
        break;
      case 'PLAZA GARIBALDI':
        appKey = 'UGxhemEgR2FyaWJhbGRp';
        break;
      case 'NELSO FERNANDO CONTRERAS CARRETO':
        appKey = 'TmVsc28gRmVybmFkbyBDb250cmVyYXMgQ2FycmV0bw';
        break;
      case 'MIGRANTES UNIDOS EN CARAVANA A C':
        appKey = 'TWlncmFudGVzIFVuaWRvcyBlbiBDYXJhdmFuYSBBIEM';
        break;
      case 'ANGELES POBLANOS':
        appKey = 'QW5nZWxlcyBQb2JsYW5vcw';
        break;
      case 'UPEXT':
        appKey = 'VVBFWFQ';
        break;
      case 'FUERZA MIGRANTE':
        appKey = 'RnVlcnphIE1pZ3JhbnRl';
        break;
      case 'LOS HIJOS AUSENTES DE CUAUTLA':
        appKey = 'TG9zIEhpam9zIEF1c2VudGVzIGRlIEN1YXV0bGE';
        break;
      case 'MANOS UNIDAS DE AMERICA AC':
        appKey = 'TWFub3MgVW5pZGFzIERlIEFtZXJpY2EgQUM';
        break;

      default:
        break;
    }

    return appKey;
  }

  menuItemClicked(url: string) {
    if (['faqs', 'support'].includes(url)) {
      this.enableMainMenu = false;
      this.enableEmbeddedHelpMenu = true;
      this.embeddedHelpViewName = url as 'faqs' | 'support';
      return;
    }

    this.router.navigateByUrl(url);
  }

  onEmbeddedHelpMenuDidClose() {
    this.enableEmbeddedHelpMenu = false;
    this.enableMainMenu = true;
  }

  async openPrivacyPolicy() {
    const _url = ((this.dBrandingService.privacyUrl && this.dBrandingService.privacyUrl !== '#') ? this.dBrandingService.privacyUrl : 'https://myboxx.app/aviso-de-privacidad/');
    await Browser.open({ url: _url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });
  }

  async openTos() {
    const _url = ((this.dBrandingService.termsUrl && this.dBrandingService.termsUrl !== '#') ? this.dBrandingService.termsUrl : 'https://myboxx.app/terms-user-boxx/');
    await Browser.open({ url: _url, toolbarColor: 'primary', presentationStyle: 'fullscreen' });

  }

  openExternalUrl(url: string) {
    this.sharingSrvc.openURL(url);
  }

  async doLogout() {
    this.boxxUtils.showAlert({
      header: this.translations.SIDEMENU.LOGOUT_ALERT.header,
      message: this.translations.SIDEMENU.LOGOUT_ALERT.message,
      buttons: [
        {
          text: this.translations.ACTIONS.ok,
          role: 'destructive',
          handler: () => {
            this.loginStore.logout();
          },
        },
        {
          text: this.translations.ACTIONS.cancel,
          cssClass: 'boxx-main-btn',
        },
      ],
    });
  }

  private handleLoading() {
    combineLatest([
      this.loginStore.loading$,
      this.onboardingStore.businessConfig.businessIsLoading$,
    ])
      .pipe(skip(1))
      .subscribe(([loginLoading, businessLoading]) => {
        if (!this.isLoginView && !this.isWelcomeView) {
          //this.boxxUtils.handleLoading(loginLoading || businessLoading);
          this.loading = false;
          return;
        }

        this.loading = loginLoading || businessLoading;
        //this.boxxUtils.handleLoading(loginLoading || businessLoading);
      });
  }

  private handleSuccess() {
    this.onboardingStore.businessConfig.businessData$.subscribe(async businessInfo => {
      if (!this.isLoginView && !this.isWelcomeView) {
        return;
      }

      if (businessInfo.isInitialData) {
        return;
      } else {
        if (businessInfo.siteUrl) {
          this.storageService.setItem(TUTORIAL_SEEN_KEY, 'OK');
        } else if (!businessInfo.businessName) {
          console.warn('===================>>>> NO business Name!!!!');

          this.router.navigateByUrl('/onboarding/gmb-survey', {
            skipLocationChange: true,
            replaceUrl: true,
          });
          return;
        } else {
          // this.router.navigateByUrl('/onboarding/business-modules-list', {
          //   //this.router.navigateByUrl('/onboarding/gmb-survey', {
          //   skipLocationChange: true,
          //   replaceUrl: true,
          // });
          // return;
        }
      }

      //this.setLanguage(businessInfo.language);

      //pre populate gmb status, for using in internal views
      if (businessInfo.config?.hasGmbAccount || businessInfo.config?.gmbCreateOrSync) {
        this.onboardingStore.businessConfig.getGmbLocationStatus();
      }

      this.storageService.setItem(TUTORIAL_SEEN_KEY, 'OK');

      await this.boxxUtils.handleLoading(false);

      //Prueba recarga
      // if(this.platformName === 'web'){
      //   if(this.lastUrl === '/'){
      //     await this.router.navigateByUrl('tabs', {
      //       skipLocationChange: true,
      //       replaceUrl: true,
      //     });
      //   }
      //   else{ 
      //     if(this.lastUrl=== '/tabs/panel'){
      //       await this.router.navigateByUrl('tabs', {
      //         skipLocationChange: true,
      //         replaceUrl: true,
      //       });
      //     }
      //     else{
      //       this.boxxUtils.handleLoading(true);
      //       this.businessService.getBusinessData().subscribe(async (data)=>{
      //         this.boxxUtils.handleLoading(false);
      //         await this.router.navigateByUrl(this.lastUrl, {
      //           skipLocationChange: true,
      //           replaceUrl: true,
      //         });
      //       });
      //     }
      //   }

      // }
      // else{
      //   await this.router.navigateByUrl('tabs', {
      //     skipLocationChange: true,
      //     replaceUrl: true,
      //   });
      // }
      //Fin prueba recarga
      await this.router.navigateByUrl('tabs', {
        skipLocationChange: true,
        replaceUrl: true,
      });
      SplashScreen.hide();
    });
  }

  private handleError() {
    this.onboardingStore.businessConfig.businessError$
      .pipe(filter(error => error?.after === 'GET'))
      .subscribe(error => {
        this.boxxUtils.showToastError({
          message: JSON.stringify(error?.error?.message),
        });
      });
  }

  private async checkEnvironment() {
    if (environment.production) {
      return;
    }

    // let message = 'TESTER MODE';

    // this.boxxUtils.showToast({
    //   message,
    //   color: 'warning',
    //   buttons: [
    //     {
    //       side: 'end',
    //       icon: 'close',
    //     },
    //   ],
    //   cssClass: 'ion-text-center',
    // });
  }

  private async setLanguage(language = 'en') {
    let langCode = (await this.storageService.getItem(
      SELECTED_LANGUAGE_LS_KEY
    )) as AvailableLanguageKeys;

    if (!langCode) {
      langCode = Object.keys(AVAILABLE_LANGUAGES).filter(
        key =>
          key === language.toLocaleLowerCase().substring(0, 2) ||
          AVAILABLE_LANGUAGES[key].name.toLowerCase() ===
          (language || 'english').toLocaleLowerCase()
      )[0] as AvailableLanguageKeys;

      //this.translateConfig.setLanguage(langCode);

      //this.storageService.setItem(SELECTED_LANGUAGE_LS_KEY, langCode);
    }
  }

  openFaqs() {
    this.router.navigateByUrl('help/faqs');
  }

  openSupport() {
    this.router.navigateByUrl('help/support');
  }


  async openPage(page) {
    this.showSalesBlock = false;
    this.showWebBlock = false;
    this.showListingBlock = false;
    
    if(page === ''){
      return;
    }
    else if(page === 'gbp'){
      this.menuCtrl.close();
        const modal = await this.viewCtrl.create({
          component: GmbStatusPage,
          componentProps: {
            optionSelected: 1
          },
  
          backdropDismiss: false,
        });
    
        await modal.present();
    }
    this.router.navigateByUrl(page);
    this.menuCtrl.close();
  }

    async openPageSupport() {
      this.menuCtrl.close();
        const modal = await this.viewCtrl.create({
          component: SupportComponent,
          componentProps: {
            optionSelected: 1
          },
  
          backdropDismiss: false,
        });
    
        await modal.present();
    }

  hideMenu() {
    this.menuCtrl.close();
  }

  async openScorePicker() {
    if (!this.previousRate) {
      const view = await this.viewCtrl.create({
        component: ScorePickerComponent,
        componentProps: {
          brandName: (this.brandName.toUpperCase() === 'TELMEX') ? 'CRM TELMEX' : this.brandName.toUpperCase(),
        }
      });

      await view.present();

      const { data } = await view.onWillDismiss();

      if (data) {
        this.stars = data.stars;

        this.router.navigateByUrl('/tabs/account/review', {
          state: { stars: data.stars, hasReview: this.previousRate, review: '' },
        });
      }
    }
    else {
      this.router.navigateByUrl('/tabs/account/review', {
        state: { stars: this.previousStars, hasReview: true, review: this.previousReview },
      });
    }

    //}
  }

  openBusiness(item) {
    this.router.navigateByUrl('/tabs/account/business-info', {
      state: { itemSelected: item },
    });
  }

  openWizard() {
    this.router.navigateByUrl('onboarding/business-configuration', {
      state: { isLoginUser: true },
    });
  }

  // openNotifications(){
  //   console.log('abrir notifications');
  // }

  // closeAlert(){
  //   this.showNotificacionToast = false;
  // }

  openBlockMenu(block: number) {
    if (block === 1) {
      this.showSalesBlock = !this.showSalesBlock;
      if (this.showSalesBlock) {
        this.showWebBlock = false;
        this.showListingBlock = false;
      }
    }
    else if (block === 2) {
      this.showWebBlock = !this.showWebBlock;
      if (this.showWebBlock) {
        this.showSalesBlock = false;
        this.showListingBlock = false;
      }
    }
    else if (block === 3) {
      this.showListingBlock = !this.showListingBlock;
      if (this.showListingBlock) {
        this.showSalesBlock = false;
        this.showWebBlock = false;
      }
    }
  }

}
